/**
 * Canonical preview identifier format used for cache keys and lookups.
 *
 * Current rules:
 * - trim surrounding whitespace
 * - remove hyphens (supports hyphenated ISBN input)
 *
 * NOTE This is focused on just the ISBN style -- it will cause problems when we implement other
 * identifers that legit have hypens (like collection slugs)
 */
export function normalizePreviewIdentifier(identifier: string): string {
  return identifier.trim().replace(/-/g, "");
}
